import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ChatModule } from '@src/app/modules/internal-messenger/chat';

import { ChatPublicPageComponent } from './chat-public-page.component';

@NgModule({
  declarations: [ChatPublicPageComponent],
  imports: [CommonModule, ChatModule, TranslateModule],
  exports: [ChatPublicPageComponent],
})
export class ChatPublicPageModule {}
